import api from '@/api'
export enum ContactsStoredType {
  /**
   * database 버전
   */
  DB,
  /**
   * exchage 버전
   */
  EWS,
}
export default {
  
}
